"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlpsDescriptor__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "baseURI",
                type: "string",
            },
        ],
        name: "BaseURIUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "DataURIToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "PartsLocked",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "accessories",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accessoryCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_accessory",
                type: "bytes",
            },
        ],
        name: "addAccessory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_background",
                type: "string",
            },
        ],
        name: "addBackground",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_body",
                type: "bytes",
            },
        ],
        name: "addBody",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_color",
                type: "string",
            },
        ],
        name: "addColorToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_glasses",
                type: "bytes",
            },
        ],
        name: "addGlasses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_head",
                type: "bytes",
            },
        ],
        name: "addHead",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_accessories",
                type: "bytes[]",
            },
        ],
        name: "addManyAccessories",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "_backgrounds",
                type: "string[]",
            },
        ],
        name: "addManyBackgrounds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_bodies",
                type: "bytes[]",
            },
        ],
        name: "addManyBodies",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string[]",
                name: "newColors",
                type: "string[]",
            },
        ],
        name: "addManyColorsToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_glasses",
                type: "bytes[]",
            },
        ],
        name: "addManyGlasses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_heads",
                type: "bytes[]",
            },
        ],
        name: "addManyHeads",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "arePartsLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "backgroundCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "backgrounds",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "bodies",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bodyCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct IAlpsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct IAlpsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "generateSVGImage",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct IAlpsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "genericDataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "glasses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "glassesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "headCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "heads",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDataURIEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockParts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "palettes",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleDataURIEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct IAlpsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60806040526000805460ff60a81b1916600160a81b17905534801561002357600080fd5b5061002d33610032565b610082565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b612c4a80620000926000396000f3fe608060405234801561001057600080fd5b506004361061025c5760003560e01c8063715018a6116101455780639a796205116100bd578063ce2f4f531161008c578063eba8180611610071578063eba81806146104e8578063f2fde38b146104f0578063f9da88631461050357600080fd5b8063ce2f4f53146104ba578063dfe8478b146104e057600080fd5b80639a79620514610479578063a51e41241461048c578063b982d1b91461049f578063cc2aa091146104b257600080fd5b8063839644da116101145780638a85a1e8116100f95780638a85a1e81461042b5780638da5cb5b1461043e57806391b7916a1461046657600080fd5b8063839644da1461040557806387db11bd1461041857600080fd5b8063715018a6146103a2578063773b9771146103aa5780637a34aad3146103df5780637ca94210146103f257600080fd5b80634531c0a8116101d85780635a503f13116101a7578063615bda101161018c578063615bda1014610374578063638ac270146103875780636c0360eb1461039a57600080fd5b80635a503f131461034e5780635e70664c1461036157600080fd5b80634531c0a8146103185780634daebac21461032057806355f804b314610328578063598fa9da1461033b57600080fd5b80632a1d07691161022f5780633cfdafd3116102145780633cfdafd3146102e05780634479cef2146102f357806344cee73c1461030557600080fd5b80632a1d0769146102c55780632ea04300146102cd57600080fd5b80630475d8631461026157806304bde4dd1461027657806317b552ab1461029f5780632715c90e146102b2575b600080fd5b61027461026f366004612123565b610516565b005b610289610284366004612165565b61063b565b60405161029691906121d6565b60405180910390f35b6102746102ad36600461222b565b6106e7565b6102746102c036600461222b565b6107c7565b6102746108a3565b6102896102db36600461236d565b6109dd565b6102896102ee366004612389565b610b37565b6007545b604051908152602001610296565b610289610313366004612165565b610ba3565b6003546102f7565b6005546102f7565b61027461033636600461222b565b610bb3565b6102896103493660046123c7565b610c65565b61028961035c366004612165565b610c9d565b61027461036f36600461222b565b610cad565b61027461038236600461222b565b610d89565b610289610395366004612389565b610e65565b610289610ed1565b610274610ede565b6000546103cf9074010000000000000000000000000000000000000000900460ff1681565b6040519015158152602001610296565b6102746103ed366004612123565b610f51565b610289610400366004612165565b61106c565b6102746104133660046123f1565b61107c565b6102896104263660046124c2565b6111c9565b610274610439366004612123565b611331565b60005460405173ffffffffffffffffffffffffffffffffffffffff9091168152602001610296565b610274610474366004612123565b61144c565b61027461048736600461222b565b611567565b61027461049a366004612123565b611643565b6102896104ad366004612165565b61175e565b6006546102f7565b6000546103cf907501000000000000000000000000000000000000000000900460ff1681565b61027461176e565b6004546102f7565b6102746104fe366004612537565b611858565b61027461051136600461256d565b611954565b60005473ffffffffffffffffffffffffffffffffffffffff1633146105825760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064015b60405180910390fd5b60005474010000000000000000000000000000000000000000900460ff16156105ed5760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b6564000000000000000000000000000000006044820152606401610579565b60005b818110156106365761062483838381811061060d5761060d6125b3565b905060200281019061061f91906125e2565b611a4e565b8061062e81612676565b9150506105f0565b505050565b6003818154811061064b57600080fd5b906000526020600020016000915090508054610666906126ae565b80601f0160208091040260200160405190810160405280929190818152602001828054610692906126ae565b80156106df5780601f106106b4576101008083540402835291602001916106df565b820191906000526020600020905b8154815290600101906020018083116106c257829003601f168201915b505050505081565b60005473ffffffffffffffffffffffffffffffffffffffff16331461074e5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610579565b60005474010000000000000000000000000000000000000000900460ff16156107b95760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b6564000000000000000000000000000000006044820152606401610579565b6107c38282611a4e565b5050565b60005473ffffffffffffffffffffffffffffffffffffffff16331461082e5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610579565b60005474010000000000000000000000000000000000000000900460ff16156108995760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b6564000000000000000000000000000000006044820152606401610579565b6107c38282611a8b565b60005473ffffffffffffffffffffffffffffffffffffffff16331461090a5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610579565b60005474010000000000000000000000000000000000000000900460ff16156109755760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b6564000000000000000000000000000000006044820152606401610579565b600080547fffffffffffffffffffffff00ffffffffffffffffffffffffffffffffffffffff16740100000000000000000000000000000000000000001781556040517f1680ee6d421f70ed6030d2fc4fcb50217a5dd617858d56562b119eca59172e579190a1565b6060600060405180604001604052806109f585611ac8565b81526020016003856000015165ffffffffffff1681548110610a1957610a196125b3565b906000526020600020018054610a2e906126ae565b80601f0160208091040260200160405190810160405280929190818152602001828054610a5a906126ae565b8015610aa75780601f10610a7c57610100808354040283529160200191610aa7565b820191906000526020600020905b815481529060010190602001808311610a8a57829003601f168201915b5050505050815250905073__$e1d8844a0810dc0e87a665b1f2b5fa7c69$__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__$e1d8844a0810dc0e87a665b1f2b5fa7c69$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";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
class AlpsDescriptor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, AlpsDescriptor__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$e1d8844a0810dc0e87a665b1f2b5fa7c69\\$__", "g"), linkLibraryAddresses["contracts/libs/NFTDescriptor.sol:NFTDescriptor"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AlpsDescriptor__factory = AlpsDescriptor__factory;
AlpsDescriptor__factory.bytecode = _bytecode;
AlpsDescriptor__factory.abi = _abi;
